import { format, setCursor, event } from './PrMoneyUtilFormat';

const defaults = {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
};

function assign(defaultsParam, extrasParam) {
  const def = defaultsParam || {};
  const extras = extrasParam || {};
  return Object.keys(def).concat(Object.keys(extras)).reduce((acc, val) => {
    acc[val] = extras[val] === undefined ? defaults[val] : extras[val];
    return acc;
  }, {});
}

export default function (element, binding) {
  let el = element.querySelector('input');

  if (!binding.value) return;
  const opt = assign(defaults, binding.value);

  // v-money used on a component that's not a input
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error(`v-money requires 1 input, found ${els.length}`);
    } else {
      el = els[0];
    }
  }

  el.oninput = () => {
    let positionFromEnd = el.value.length - el.selectionEnd;
    el.value = format(el.value, opt);
    positionFromEnd = Math.max(positionFromEnd, opt.suffix.length); // right
    positionFromEnd = el.value.length - positionFromEnd;
    positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1); // left
    setCursor(el, positionFromEnd);
    el.dispatchEvent(event('change')); // v-model.lazy
  };

  el.onfocus = () => {
    setCursor(el, el.value.length - opt.suffix.length);
  };

  el.oninput();

  setTimeout(() => {
    el.dispatchEvent(event('input'));
  }, 100);
}

export { defaults };



// WEBPACK FOOTER //
// ./src/components/widgets/PrMoneyDirective.js